import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    deviceCode: localStorage.getItem('deviceCode') || '',
    testId: localStorage.getItem('testId') || ''
  },
  getters: {
    getDeviceCode: state => state.deviceCode,
    getTestId: state => state.testId
  },
  mutations: {
    setDeviceCode(state, code) {
      state.deviceCode = code;
      localStorage.setItem('deviceCode', code);
    },
    setRefresh(state, testId) {
      state.testId = testId;
      localStorage.setItem('testId', testId);
    }
  },
  actions: {
    updateDeviceInfo({ commit }, { deviceCode, testId }) {
      if (deviceCode) {
        commit('setDeviceCode', deviceCode);
      }
      if (testId) {
        commit('setRefresh', testId);
      }
    }
  },
  modules: {}
})
